import { useMutation } from "@tanstack/react-query";
import { reportSpaceIssue } from "../../../apis/flag";
import { AddPhotoImageData } from "../../../types";

export function useFlagSpaceAccessibility() {
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      reviewLevelId,
      businessId,
      notes,
      accessToken,
      images,
    }: {
      reviewLevelId: string;
      businessId: string;
      notes: string;
      accessToken: string;
      images: AddPhotoImageData[];
    }) => {
      return reportSpaceIssue(reviewLevelId, businessId, notes, accessToken, images);
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
